import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, MutationAction, getModule } from 'vuex-module-decorators';
import UserDto from '@/models/Users/UserDto';
import AppDto from '@/models/Apps/AppDto';
import store from '@/store';
import { AppModule } from './app';
import UpdateAppRequest from '@/models/Apps/UpdateAppRequest';

export interface ISysState {
  loading: boolean; 
  currentSysAdminUser: UserDto | null;
  sysAdminUsers: UserDto[];
  currentWorkerUser: UserDto | null;
  workerUsers: UserDto[];
  currentApp: AppDto | null;
  apps: AppDto[];
  loadingDialog: boolean;
}

@Module({ dynamic: true, store, name: 'Sys', namespaced: true })
class Sys extends VuexModule implements ISysState {
 
  public loading = true;
  public currentSysAdminUser: UserDto = new UserDto();
  public sysAdminUsers: UserDto[] = []; 
  public currentWorkerUser: UserDto = new UserDto();
  public workerUsers: UserDto[] = []; 
  public currentApp: AppDto = new AppDto();
  public apps: AppDto[] = [];  
  public loadingDialog = false;
 
  @Action
  async getSysAdminUsers() {
    this.setLoading(true);
    await ajax.get(`/api/v1/sys/users?userType=SysAdmin`)
    .then(response => {
      this.context.commit("setSysAdminUsers", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getWorkerUsers() {
    this.setLoading(true);
    await ajax.get(`/api/v1/sys/users?userType=Worker`)
    .then(response => {
      this.context.commit("setWorkerUsers", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getApps() {
    this.setLoading(true);
    await ajax.get(`/api/v1/sys/apps`)
    .then(response => {
      this.context.commit("setApps", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async triggerPasswordReset(id: string) {
    this.setLoadingDialog(true);
    await ajax.post(`/api/v1/sys/users/${id}/trigger-password-reset`)
    .then(response => {
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    });
  }

  @Action
  public async updateCurrentSysAdminUser(user: UserDto){
    this.context.commit("setCurrentSysAdminUser", user);
  }

  @Action
  public async updateCurrentWorkerUser(user: UserDto){
    this.context.commit("setCurrentWorkerUser", user);
  }

  @Action
  public async updateCurrentApp(app: AppDto){
    this.context.commit("setCurrentApp", app);
  }

  @Action
  public async editApp(request: UpdateAppRequest) {
    this.setLoadingDialog(true); 
    await ajax.put(`/api/v1/sys/apps/${this.currentApp.id}`, request)
    .then(response => {
      this.context.commit("setAppFromEdit", response.data);
      this.setLoadingDialog(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoadingDialog(false);
    })
  }

  // @Action
  // public async resetUserPassword(request: ResetUserPasswordRequest) {
  //   this.setLoadingDialog(true); 
  //   await ajax.put(`/api/v1/sys/users/${this.currentAgencyUser.id}/password`, request)
  //   .then(response => {
  //     this.context.commit("setUserFromEdit", response.data);
  //     this.setLoadingDialog(false);
  //   })
  //   .catch(error => {
  //     AppModule.handleApiError(error);
  //     this.setLoadingDialog(false);
  //   })
  // }

  // @Action
  // public async deleteUser(request: UpdateUserStatusRequest) {
  //   this.setLoadingDialog(true); 
  //   await ajax.put(`/api/v1/sys/users/${this.currentUser.id}/status`, request)
  //   .then(response => {
  //     this.context.commit("setUserFromEdit", response.data);
  //     this.setLoadingDialog(false);
  //   })
  //   .catch(error => {
  //     AppModule.handleApiError(error);
  //     this.setLoadingDialog(false);
  //   })
  // }

  // @Action
  // public async createUser(user: CreateUserRequest) {
  //   this.setLoadingDialog(true); 
  //   await ajax.post(`/api/v1/sys/users`, user)
  //   .then(response => {
  //     this.context.commit("setUserFromCreate", response.data);
  //     this.setLoadingDialog(false);
  //   })
  //   .catch(error => {
  //     AppModule.handleApiError(error);
  //     this.setLoadingDialog(false);
  //   })
  // }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.currentSysAdminUser = new UserDto();
    this.currentWorkerUser = new UserDto();
    this.currentApp = new AppDto();
    this.sysAdminUsers = [];
    this.workerUsers = [];
    this.apps = [];
    this.loading = true;
    this.loadingDialog = false;
 
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }
  
  @Mutation
  private async setSysAdminUsers(users: UserDto[]) {
      this.sysAdminUsers = users;
      if (users && users.length > 0) {
        this.currentSysAdminUser = this.sysAdminUsers[0];
      }
  }

  @Mutation
  private async setWorkerUsers(users: UserDto[]) {
      this.workerUsers = users;
      if (users && users.length > 0) {
        this.currentWorkerUser = this.workerUsers[0];
      }
  }
  
  @Mutation
  private async setCurrentSysAdminUser(user: UserDto) {
      this.currentSysAdminUser = user;
  }


  @Mutation
  private async setCurrentWorkerUser(user: UserDto) {
      this.currentWorkerUser = user;
  }


  @Mutation
  private async setSysAdminUserFromEdit(user: UserDto) {
    this.currentSysAdminUser = user;
    const index = this.sysAdminUsers.findIndex((findUser: UserDto) => user.id === findUser.id);
    this.sysAdminUsers[index] = user;
  }

  @Mutation
  private async setWorkerUserFromEdit(user: UserDto) {
    this.currentWorkerUser = user;
    const index = this.workerUsers.findIndex((findUser: UserDto) => user.id === findUser.id);
    this.workerUsers[index] = user;
  }

  @Mutation
  private async setSysAdminUserFromCreate(user: UserDto) {
    this.currentSysAdminUser = user;
    this.sysAdminUsers.push(user);
  }

  @Mutation
  private async setApps(apps: AppDto[]) {
      this.apps = apps;
      if (apps && apps.length > 0) {
        this.currentApp = this.apps[0];
      }
  }
  
  @Mutation
  private async setCurrentApp(app: AppDto) {
      this.currentApp = app;
  }

  @Mutation
  private async setAppFromEdit(app: AppDto) {
    this.currentApp = app;
    const index = this.apps.findIndex((findApp: AppDto) => app.id === findApp.id);
    this.apps[index] = app;
  }

}

export const SysModule = getModule(Sys)
